<template>
  <div class="company">
      <div class="main-conter">
          <div class="tabTxt_box">
            <div class="tabTxt">
                <h2 class="line-title">合作伙伴</h2>
                <!-- <p class="smTitle">申请成为官方Handle前缀代理商，国际认可、客户信任、收益共享、共建生态</p> -->
                <el-row :gutter="10">
                    <el-col :xs="{span:22,offset:1}" :sm="{span:4,offset:0}" :lg="{span:6,offset:0}">
                        <div class="grid-content2 bg-purple">
                            <div class="Partners_item"><img src="./../../assets/img/products/Partners/SKG.png" alt=""></div>
                            <div class="Partners_mask">
                                <!-- <img class="mask_logo" src="./../../assets/img/products/Partners/SKG.png" alt=""> -->
                                <p>时空根（杭州）科技有限公司<br/>86.18</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="{span:22,offset:1}" :sm="{span:4,offset:0}" :lg="{span:6,offset:0}">
                        <div class="grid-content2 bg-purple">
                            <div class="Partners_item"><img src="./../../assets/img/products/Partners/DQJU.png" alt=""></div>
                            <div class="Partners_mask">
                                <p>中铁大桥局集团有限公司<br/>86.1953</p>
                            </div>
                        </div>
                    </el-col>
                    <!-- <el-col :xs="{span:22,offset:1}" :sm="{span:4,offset:0}" :lg="{span:4,offset:1}">
                        <div class="grid-content2 bg-purple">
                            <div class="Partners_item"><img src="./../../assets/img/products/Partners/tty.png" alt=""></div>
                            <div class="Partners_mask">
                                <p>上海塘塘云网络科技有限公司<br/>86.888</p>
                            </div>
                        </div>
                    </el-col> -->
                    <el-col :xs="{span:22,offset:1}" :sm="{span:4,offset:0}" :lg="{span:6,offset:0}">
                        <div class="grid-content2 bg-purple">
                            <div class="Partners_item"><img src="./../../assets/img/products/Partners/SDGK.png" alt=""></div>
                            <div class="Partners_mask">
                                <p>山东港口产城融合发展集团<br/>有限公司<br/>86.66666</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <router-link to="/AttractInvestment" class="more">查看更多>></router-link>
            </div>
          </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'Partner',
  components: {
  }
}
</script>

<style lang="less" scoped>
.company {
    .main-conter {
        width: 100%;
        .tabTxt_box{
            background: url('./../../assets/img/products/ball.png') repeat center;
            padding: 1px 0 30px 0;
        }
        .tabTxt {
            width: 1200px;
            margin:100px auto;
            .more{
                display: block;
                color: #0065dd;
                font-size: 16px;
                text-align: center;
                margin-top: 50px;
            }
            .line-title {
                font-size: 30px;
                color: #333;
                text-align: center;
                margin: 50px 0;
            }
             h2.line-title:after {
                content: '';
                width: 60px;
                height: 3px;
                display: block;
                background-color: #3b9cfb;
                border-radius: 5px;
                margin: 15px auto 0;
             }
             .smTitle{
                font-size: 14px;
                color: #505050;
                margin:-25px 0 40px 0;
                text-align: center;
             }
             .el-row {
                margin-bottom: 20px;
                &:last-child {
                margin-bottom: 0;
                }
            }
            .el-col {
                border-radius: 4px;
                .grid-content, .grid-content2 {
                    overflow: hidden;
                    padding: 20px 30px;
                    height: 430px;
                    .iconImg {
                        width:140px;
                        height: auto;
                        margin: 20px auto;
                        img {
                            width:100%;
                            height: auto;
                        }
                    }
                    h3 {
                        color: #1f2d3d;
                        font-size: 24px;
                        font-weight: 400;
                        line-height: 36px;
                        margin: 10px auto 15px;
                        border-bottom: 1px solid #f1f1f1;
                        text-align: center;
                        padding: 0 0 14px 11px;
                    }
                }
                .grid-content2{
                    position: relative;
                    padding: 0;
                    height: 120px;
                    display: flex;
                    align-items: center;
                    justify-items: center;
                    .Partners_item{
                        width: 178px;
                        height: 43px;
                        margin: auto;
                        text-align: center;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .Partners_mask{
                        position: absolute;
                        top: 121px;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color:#021234e8;
                        text-align: center;
                        display: flex;
                        transition: all 333ms ease;
                        p{
                            text-align: center;
                            color: #fff;
                            align-self: center;
                            flex: auto;
                        }
                        img.mask_logo{
                            width: 80%;
                            height: auto;

                        }
                    }
                }
                .grid-content2:hover .Partners_mask{
                    top: 0;
                }
                .address-content{
                    width:100%;
                    padding:20px 30px;
                    height:340px;
                    img{
                        width:100%;
                        height:auto;
                    }
                    .address {
                        span{
                            font-size:16px;
                        }
                        .addressName {
                            font-weight: bold;
                            display: inline-block;
                            margin:5px 0;
                        }
                    }
                }
            }
            .bg-purple {
                background: #fff;
                box-shadow:0 4px 10px 0 rgb(26 38 52 / 15%);
            }
            .grid-content {
                border-radius: 4px;
                min-height: 36px;
            }
            .row-bg {
                padding: 10px 0;
                background-color: url('./../../assets/img/products/ball.png')
            }
        }
    }
}
@media screen and (max-width: 1000px) {
  .company {
    .main-conter{
         .tabBar {
             .tabs {
                 width: 300px;
                 a {
                        display:inline-block;
                        padding: 25px 25px !important;
                        font-size: 16px;
                        color:#2e3d5f;
                     }
            }
         }
         .tabTxt{
             width:100%;
         }
         .grid-content {
             margin:10px 0;
         }
         .address-content {
             height:277px !important;
             margin:10px 0
         }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/Home/components/Partner.vue